// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vcz3","rootNoMargin":"styles_rootNoMargin__1oD6p"};